import React from "react";

const PropertyType = ({ selectedSubcat = [], handleSubcatPress }) => {
  const propertyTypes = [
    "Flat/apartment",
    "Independent House",
    "Villa",
    "Independent/Builder Floor",
    "1 RK/Studio Apartment",
    "Land",
    "Plot",
    "Farmhouse",
    "Service Apartment",
  ];

  return (
    <div className="mainbarfiltercomponents">
      {propertyTypes.map((type, index) => {
        const isChecked = selectedSubcat.includes(type);
        return (
          <div
            className="propertyboxes"
            key={index}
            onClick={() => handleSubcatPress && handleSubcatPress(type)}
            style={{ cursor: "pointer" }}
          >
            <input
              type="checkbox"
              checked={isChecked}
              onChange={() => {}}
              style={{ cursor: "pointer" }}
            />
            <p className="propertytextpara" style={{ margin: 0, paddingLeft: "8px" }}>
              {type}
            </p>
          </div>
        );
      })}
    </div>
  );
};

export default PropertyType;